import React, { useState } from 'react';
import { signTypes, customEventTypes } from '../../constants.js';
import i18next from '../../i18n.js'; 
import { Button } from 'react-bootstrap';
import QRCodeForm from './QRCodeForm.js';
import { eventDispatcher } from '../../eventDispatcher.js';

const SignDocumentForm = (props) => {
    const [signType, setSignType] = useState(null);

    const getTitmerLength = () => (signType === signTypes.diia) ? 3 * 60 : 5 * 60;

    const onStartDiiaSign = () => {
        setSignType(signTypes.diia);
        eventDispatcher.invokeEvent(customEventTypes.onSignStarted, props.docId);
    }

    const onStartSmartIdSign = () => {
        setSignType(signTypes.smartId);
        eventDispatcher.invokeEvent(customEventTypes.onSignStarted, props.docId);
    }

    const onStartMonobankSign = () => {
        setSignType(signTypes.monobank);
        eventDispatcher.invokeEvent(customEventTypes.onSignStarted, props.docId);
    }

    return (<div className='sign-document-form'>
        {signType === null && <div className='sign-type-btns'>
            <Button className="diia" variant="secondary" onClick={onStartDiiaSign}>{i18next.t("widgets.signWidget.signDiiaBtn")}</Button>
            <Button className="smartId" variant="secondary" onClick={onStartSmartIdSign}>{i18next.t("widgets.signWidget.signSmartIdBtn")}</Button>
            <Button className="monobank" variant="secondary" onClick={onStartMonobankSign}>{i18next.t("widgets.signWidget.signMonobankBtn")}</Button>
        </div>}
        {signType !== null && <QRCodeForm type={signType} docId={props.docId} taskId={props.taskId} secconds={getTitmerLength()} onError={props.onError} />}
    </div>);
}

export default SignDocumentForm;